import { useMemo } from "react";
import useSWR from "swr";
import { deflate } from "zlib";
import apiService from "./ApiService";
import useCategoryTree, { useCategoryTag } from "./useCategoryTree";

function useCurrentCategoryIds(nodeId: any) {
  const { tree, error, isLoading } = useCategoryTree();

  const ids = useMemo(() => {

    let ids = new Array();

    for (let item in tree && tree.children) {
      let arr = new Array(tree.children[item]);
      let currCateId = CurrentCategoryId(arr, nodeId, []);
      if (currCateId[0] != nodeId) {
        ids.push(currCateId);
      }
    }

    if (tree && ids.length == 0) {
      ids.push([nodeId])
    }
    if (tree) {
      setCategoryID(ids);
    } 

  }, [tree, nodeId])

  return ids;
}

function CurrentCategoryId(tree: any, nodeId: string, config: any) {

  const { children = 'children', id = 'categoryTagId' } = config || {}

  const toFlatArray = (tree: any, parentId: any) => {

    return tree.reduce((t: any, _: any) => {

      const child = _[children]

      return [

        ...t,

        parentId ? { ..._, parentId } : _,

        ...(child && child.length ? toFlatArray(child, _[id]) : [])]

    }, [])

  }

  const getIds = (flatArray: any[]) => {

    let ids = [nodeId]

    let child = flatArray.find(_ => _[id] === nodeId)

    while (child && child.parentId) {

      ids = [child.parentId, ...ids]

      child = flatArray.find(_ => _[id] === child.parentId)

    }

    return ids

  }

  return getIds(toFlatArray(tree, ''))

}

function isArrayInArray(arr: any, item: any) {

  var item_as_string = JSON.stringify(item);

  var contains = arr.some(function (ele: any) {
    return JSON.stringify(ele) === item_as_string;
  });

  return contains;
}

function useCategoryTagbySKU(sku: any) {
  const { tree, error, isLoading } = useCategoryTree();
  
  const { data } = useCategoryTag(sku); 

  const ids =useMemo(() => {
 
    if (data && tree) {

      console.log(data);
  
      let ids = new Array();
  
      for (let cate of data) {
  
        let nodeId = cate.categoryTagId;
  
        for (let item in tree && tree.children) {
  
          let arr = new Array(tree.children[item]);
  
          let currCateId = CurrentCategoryId(arr, nodeId, []);
  
          if (currCateId[0] != nodeId) {
            ids.push(currCateId);
          }
  
        }  
      }  
      setCategoryID(ids); 
  }},[tree,sku])
  
    return ids;
  }


function setCategoryID(ids: any) {

  if(ids.length==0){
    return;
  }

  console.log(ids);

  let existIds1 = [window.localStorage.getItem("currentCategoryID"), window.localStorage.getItem("subCurrentCategoryID"), window.localStorage.getItem("thirdCurrentCategoryID")];
  let existIds2 = [window.localStorage.getItem("currentCategoryID"), window.localStorage.getItem("subCurrentCategoryID")];

  if (!isArrayInArray(ids, existIds1) && !isArrayInArray(ids, existIds2)) {

    switch (ids[0].length) {
      case 1:
        window.localStorage.setItem("currentCategoryID", ids[0][0])
        window.localStorage.setItem("subCurrentCategoryID", "")
        window.localStorage.setItem("thirdCurrentCategoryID", "")
        break;
      case 2:
        window.localStorage.setItem("currentCategoryID", ids[0][0])
        window.localStorage.setItem("subCurrentCategoryID", ids[0][1])
        window.localStorage.setItem("thirdCurrentCategoryID", "")
        break;
      default :
        window.localStorage.setItem("currentCategoryID", ids[0][0])
        window.localStorage.setItem("subCurrentCategoryID", ids[0][1])
        window.localStorage.setItem("thirdCurrentCategoryID", ids[0][2])
        break;
    }
  }

  return ids;
}


export { useCurrentCategoryIds, useCategoryTagbySKU }

